import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, Button, message } from "antd"
import { listBatchesV4, startCutLaze, finishCutLaze } from '../../../services/api/3dApi'

const InputCutLaze = () => {

    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [isStart, setIsStart] = useState(false)
    const [isFinish, setIsFinish] = useState(false)
    const [errorInput, setErrorInput] = useState('')
    const [batchesId, setBatchesId] = useState('')

    const _onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        setIsStart(false)
        setIsFinish(false)

        const checkValue = /^\w+-\d/.test(valueInput)
        if (!checkValue || !valueInput.trim()) {
            setErrorInput('Mã lô sai định dạng.')
            setLoading(false)
        }

        if (checkValue && valueInput.trim()) {
            try {
                const { data } = await listBatchesV4({ name: valueInput })
                const { data: res } = Object.assign({}, data)
                const { batches } = res

                if (!batches.length > 0) return Modal.error({
                    title: 'Lỗi',
                    content: 'Không tìm thấy tên lô',
                    onOk: _resetScanInput(),
                    okText: 'Đóng'
                })

                const { _id, status, name } = Object.assign({}, ...batches)
                setBatchesId(_id)
                const is_LazeCut = batches.some(item => item.lasers)

                if (!['transferred', 'wait_to_sew', 'sewing'].includes(status)) return message.error(`Batch ${name} is ${status}, cannot cut by laser.`)

                if (is_LazeCut) {
                    const { lasers } = Object.assign({}, ...batches)
                    if (!lasers.length) return setIsStart(true)

                    const newLasers = lasers.pop()

                    const { finished_at } = Object.assign({}, newLasers)

                    if (!finished_at) return setIsFinish(true)

                    return setIsStart(true)
                }

                return setIsStart(true)

            } catch (error) {
                setErrorInput(error)
            } finally {
                setLoading(false)
            }
        }
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
        setIsStart(false)
        setIsFinish(false)
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
        setIsStart(false)
        setIsFinish(false)
    }

    const handleStartCutting = async (e) => {
        e.preventDefault()
        setLoading(true)
        setErrorInput('')

        try {
            const { data: response } = await startCutLaze(batchesId)
            const { error, success } = Object.assign({}, response)

            if (!success) return message.error(error)

            message.success('Bắt đầu cắt thành công!')
            _resetScanInput()

        } catch (error) {
            message.error(error)
        } finally {
            setLoading(false)
        }

    }

    const handleFinishCutting = async (e) => {
        e.preventDefault()
        setLoading(true)
        setErrorInput('')

        try {
            const { data: response } = await finishCutLaze(batchesId)
            const { error, success } = Object.assign({}, response)

            if (!success) return message.error(error)

            message.success('Kết thúc cắt thành công!')
            _resetScanInput()

        } catch (error) {
            message.error(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="UpdateLazeCutting">
            <div className="UpdateLazeCuttingPage">
                <div className="position-relative">
                    <Spin spinning={loading} tip='Đang kiểm tra...'>
                        <form onSubmit={_onSubmit} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={_input}
                                autoFocus={true}
                                placeholder='Nhập vào tên lô'
                                onChange={_handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={_resetScanInput}
                                />
                            }

                            {
                                loading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }

                            {
                                (!loading) && isStart &&
                                <Button
                                    type='primary'
                                    className='float-right mt-3 px-4'
                                    onClick={handleStartCutting}
                                >
                                    Bắt đầu cắt Laze
                                </Button>
                            }

                            {
                                (!loading) && isFinish &&
                                <Button
                                    type='primary'
                                    className='float-right mt-3 px-4'
                                    onClick={handleFinishCutting}
                                >
                                    Kết thúc cắt Laze
                                </Button>
                            }
                        </form>

                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                    </Spin>
                </div>
            </div>
        </div>
    )
}

export default InputCutLaze